<template>
	<modal id="termsConditions" isLarge="true">
		<template slot="title" class="title">Payment Terms and Conditions</template>
		<template slot="body">
			<div class="mt-3">
				<p>
					This website is maintained by ConstellationMutual.com and its subsidiaries’ or
					businesses operating under the Constellation portfolio of brands, including, but
					not limited to, MMIC Insurance, Inc., UMIA Insurance, Inc., Arkansas Mutual
					Insurance Company and InsureCAREteams™, a product of MMIC Insurance, Inc., and
					UMIA Insurance, Inc., (collectively “Constellation, “us”, “our”, “site”,
					“website”, or “we”). All payments are managed with a PCI/DSS-compliant payment
					process service to which Constellation subscribes and Constellation does not
					process or store your payment card number. Constellation does not view, collect
					or retain your payment card information.
				</p>
				<p>
					This payment is for coverage with {{ tocBranding }}, your billing statement will
					indicate payment to {{ tocBranding }} for this coverage.
				</p>
				<p>
					Your receipt will be emailed to the primary email address indicated on your
					policyholder account.
				</p>
				<p>
					You will be able to view your policy documents and modify your payment method on
					your {{ Brand.getProperBrand() }} Policyholder Account dashboard.
				</p>
				<p>
					In order to cancel your {{ Brand.getProperBrand() }} policy, please provide
					written instructions, including your last day of coverage, via mail, fax or
					email. The policy will be cancelled at 12:01 AM on the following business day.
					The premium for Tail Coverage is due within 60 days of the effective
					cancellation date.
				</p>
				<p>
					For policy, payment frequency changes and if you have any other questions
					related to your policy, please call
					<u class="highlight">{{ Brand.getBrandInformation().phone_number }}</u
					>. An underwriter will be happy to help you.
				</p>
				<p>
					For policy coverage and payment questions related to
					{{ Brand.getProperBrand() }}, contact us at:<br />
					<u class="highlight">{{ Brand.getBrandInformation().email_address }}</u>
					<br />
					<u class="highlight">{{ Brand.getBrandInformation().phone_number }}</u>
				</p>
			</div>
		</template>
		<template slot="footer">
			<button class="btn myaccount_btn--green w-50 mr-auto" data-dismiss="modal">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal/Base3.vue';
import Brand from '@/services/Brand';

export default {
	name: 'TermsConditions',
	components: {
		Modal,
	},
	data() {
		return {
			Brand,
		};
	},
	computed: {
		tocBranding() {
			switch (Brand.getBrand()) {
				case 'umia':
					return 'UMIA Insurance, Inc.';
					break;

				case 'mmic':
					return 'MMIC Insurance, Inc.';
					break;

				case 'amic':
					return 'Arkansas Mutual Insurance Company';
					break;

				case 'insurecareteams':
					return 'InsureCAREteams';
					break;
			}
		},
	},
};
</script>
<style lang="scss" scoped></style>
